import React, { useEffect, useContext, useState } from "react";
import { developAxios } from "../axios.config";
import { useParams } from "react-router-dom";
import { WeeklyContext } from "../Context/WeeklyContext";
const GetAssignmentQuestions = () => {
	const params = useParams();
	const [assignmentName, setAssignmentName] = useState();
	const [assgnmentType, setAssignmentType] = useState([]);
	const [questionData, setQuestionData] = useState([]);
	const { allQuestions, setAllQuestions, questionId, setQuestionId } =
		useContext(WeeklyContext);
	const assignment = ["Home Assignment", "Class Assignment"];
	useEffect(() => {
		developAxios(localStorage.getItem("token"))
			.get(
				`/pd-online/getAllQuestionsInAssignmentTypes/${params._id}/${params.id}`
			)
			.then(({ data }) => {
				console.log(data);
				setQuestionData(data.data);
			})
			.catch((e) => {
				console.log(e);
			});
	}, []);
	const handleClick = () => {
		developAxios(localStorage.getItem("token"))
			.put(`/pd-online/putQuestionsInAssignmentTypes/${params._id}`, {
				questionId: questionId,
				assignmentName: assignmentName,
			})
			.then(({ data }) => {
				console.log(data);
				setAssignmentType(data);
			})
			.catch((e) => {
				console.log(e);
			});
	};
	useEffect(() => {
		developAxios(localStorage.getItem("token"))
			.get(`/GetAllQuestionAdmin`)
			.then(({ data }) => {
				console.log(data.questions, "hello");
				setAllQuestions(data.questions);
			})
			.catch((e) => {
				console.log(e);
			});
	}, []);

	return (
		<div>
			<div className="flex justify-center mt-5">
				<div className="mb-3 xl:w-1/2">
					<h1 className="mb-5"> Add Assignment Quesitons</h1>
					<select
						onChange={(e) => setQuestionId(e.target.value)}
						className="form-select appearance-none
  block
  w-full
  px-3
  py-1.5
  text-base
  font-normal
  text-gray-700
  bg-white bg-clip-padding bg-no-repeat
  border border-solid border-gray-300
  rounded
  transition
  ease-in-out
  mb-5
 1/2 w-
  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
						aria-label="Default select example"
					>
						{allQuestions.map((e) => {
							return (
								<option value={e._id} key={e._id}>
									{e.name}
								</option>
							);
						})}
					</select>

					<select
						onChange={(e) => setAssignmentName(e.target.value)}
						className="form-select appearance-none
block
w-full
px-3
py-1.5
text-base
font-normal
text-gray-700
bg-white bg-clip-padding bg-no-repeat
border border-solid border-gray-300
rounded
transition
ease-in-out
1/2 w-

focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
						aria-label="Default select example"
					>
						{assignment.map((e) => {
							return <option value={e}>{e}</option>;
						})}
					</select>
					<button
						className="rounded-full
    bg-sky-500 hover:bg-sky-700 py-2 px-4 text-stone-50	mt-5 "
						onClick={handleClick}
					>
						Add Quesitons
					</button>
				</div>
			</div>

			<ol className="border-l md:border-l-0 md:border-t border-gray-300 md:flex md:justify-center md:gap-6">
				<li>
					<div className="flex md:block flex-start items-center pt-2 md:pt-0">
						{questionData.map((e) => {
							return (
								<>
									<div className="bg-gray-300 w-2 h-2 rounded-full -ml-1 md:ml-0 mr-3 md:mr-0 md:-mt-1"></div>
									<p className="text-gray-500 text-sm mt-2">
										{e.createdAt}
									</p>
									<div className="mt-0.5 ml-4 md:ml-0 pb-5">
										<h4 className="text-gray-800 font-semibold text-xl mb-1.5">
											{e.name}
										</h4>
										<p className="text-gray-500 mb-3">
											{e.description}
										</p>
									</div>
								</>
							);
						})}
					</div>
				</li>
			</ol>
		</div>
	);
};

export default GetAssignmentQuestions;
